import { render } from "./Header.vue?vue&type=template&id=823f8b4a&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=823f8b4a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-823f8b4a"

export default script